import { useEffect, useState } from 'react';
import useRainbows from '../hooks/useRainbows';
import useTokenVault from './useTokenVault';

import { ZERO } from '../util';

const useVaultBalance = () => {
  const rainbows = useRainbows();
  const tokenVault = useTokenVault();

  const [vaultBalance, setVaultBalance] = useState(ZERO);

  useEffect(() => {
    let ignore = false;
    setVaultBalance(ZERO);
    if (rainbows && tokenVault) {
      const fetchVaultBalance = () =>
        rainbows.balanceOf(tokenVault.address).then((balance) => {
          if (!ignore) setVaultBalance(balance);
        });
      fetchVaultBalance();
      const transferFrom = rainbows.filters.Transfer(tokenVault.address);
      const transferTo = rainbows.filters.Transfer(null, tokenVault.address);
      rainbows.on(transferFrom, fetchVaultBalance);
      rainbows.on(transferTo, fetchVaultBalance);
      return () => {
        rainbows.off(transferFrom, fetchVaultBalance);
        rainbows.off(transferTo, fetchVaultBalance);
        ignore = true;
      };
    }
  }, [rainbows, tokenVault]);

  return vaultBalance;
};

export default useVaultBalance;
